import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useDashboard } from "@/lib/dataContext";

export const DashboardLayout = () => {
    const { data, stateMeta } = useDashboard();
    const stateName = data?.state_profile?.state_name || data?.executive_summary?.state_name || stateMeta?.state_name || "State";
    const period = data?.reporting_period?.period_label || "FY 2025–26";
    return (
        <TooltipProvider delayDuration={150}>
            <div className="min-h-screen bg-background">
                <Sidebar />
                <div className="lg:pl-[264px]">
                    <Header />
                    <main className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
                        <Outlet />
                    </main>
                    <footer className="mx-auto max-w-[1400px] px-4 pb-10 pt-4 sm:px-6 lg:px-8">
                        <p className="border-t border-border/60 pt-5 text-center text-xs text-muted-foreground">
                            Sri Sathya Sai Seva Organisations &mdash; {String(stateName).trim()} &middot; Organisational Performance Dashboard, {period}
                        </p>
                    </footer>
                </div>
            </div>
        </TooltipProvider>
    );
};
